// extracted by mini-css-extract-plugin
export var burgerStyles = "NavStyles-module--burgerStyles--2ad15";
export var headerStyles = "NavStyles-module--headerStyles--fae5a";
export var navigationStyles = "NavStyles-module--navigationStyles--7fdf2";